const blacklist = ['Bytespider; spider-feedback@bytedance.com'];
const browserAllowed = (userAgent) => {
    return !blacklist.some((item) => userAgent.includes(item));
};
export { browserAllowed };
